export default __webpack_public_path__ + "dff3b3dcf56c10418804123d5a8e221c.svg";